import vue from '@/main.js'
// 判断是否是移动端
export function isMobile() {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  return flag;
}

// 通过name 获取路由地址
export function getRouterByName(name) {
  const routes = vue.$router.options.routes
  // console.log(routes)
  let path = ''
  for (let j in routes) {
    const childrens = routes[j].children
    for (let i of childrens) {
      if (i.dbSource === name) {
        path = i.path
        break
      } 
    }
    if (path) {
      break
    }
  }
  return path
}
// 添加事件
export function addEvent (obj, sEv, fn) {
  if (obj.addEventListener) {
    obj.addEventListener(sEv, fn, false)
  } else {
    obj.attachEvent('on' + sEv, fn)
  }
}
// 添加滚动条事件
export function addWheel (obj, fn) {
  function fnWheel (ev) {
    var oEvent = ev || event
    var bDown = false
    bDown = oEvent.wheelDelta ? oEvent.wheelDelta < 0 : oEvent.detail > 0
    fn && fn(oEvent,bDown)
    oEvent.preventDefault && oEvent.preventDefault()
    return false
  }
  if (window.navigator.userAgent.indexOf('Firefox') != -1) {
    obj.addEventListener('DOMMouseScroll', fnWheel, false)  
  } else {
    addEvent(obj,'mousewheel',fnWheel)
  }
}


// WEBPACK FOOTER //
// ./src/utils/common.js